import React, { useEffect } from "react";
import { LoginForm } from "../components/auth";
import authImage from "../assets/auth-login-image.png";

const Login: React.FC = () => {
  const handleLoginSuccess = () => {
    // Redirect to dashboard after successful login
    // navigate('/app');
  };

  const handleLoginError = (error: Error) => {
    console.error("Login error:", error);
    // Additional error handling can be added here
  };

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handleBackButton = () => {
      window.history.pushState(null, "", window.location.href);
    };

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener("popstate", handleBackButton);
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Left Side Image Section */}
      <div className="hidden md:block w-1/2 overflow-hidden p-4">
        <img src={authImage} alt="hello" />
      </div>
      {/* Right Side Form Section */}
      <div className="flex flex-col justify-center items-center w-full md:w-1/2 px-8 py-12">
        <div className="w-full max-w-xl">
          <div className="text-2xl font-bold text-primary-button mb-4">
            Medicare Connect AI
          </div>
          <h2 className="text-3xl font-bold mb-0 text-gray-900">
            Welcome to{" "}
            <span className="text-primary-button">Medicare Connect AI</span>
          </h2>
          <p className="text-gray-600 text-sm mb-8">
            Sign in to manage AI calling campaigns,appointments,
            follow-up reminders, and engagement workflows.
          </p>
          <LoginForm
            onSuccess={handleLoginSuccess}
            onError={handleLoginError}
            // redirectTo="/app"
            showRememberMe={false}
            showForgotPassword={true}
            showSignUp={false}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
